var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":"info","disabled":!_vm.loginable,"block":""},on:{"click":_vm.login}},[_vm._v(" ログイン ")])}
var staticRenderFns = []

export { render, staticRenderFns }